// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-cube-meta.ts
import type {
  CubeMeasureEntry,
  CubeDimensionEntry,
  CubeJoinEntry
} from 'shared/src/api/cube-api-types';

export const mediaBuyMetricsDailyCubeMeta = {
  name: 'media_buy_metrics_daily',
  sqlTable: 'metrics.media_buy_metrics_daily',
  title: 'Media Buy Metrics Daily',
  description:
    'Daily grain metrics per media buy. Use for time-series. Rows with NULL line_item_id/media_plan_id represent unassociated media buy spend.',
  joins: {
    line_items: { relationship: 'many_to_one' } as const satisfies CubeJoinEntry,
    media_buys: { relationship: 'many_to_one' } as const satisfies CubeJoinEntry
  },
  measures: {
    'media_buy_metrics_daily.impressions': {
      sql: 'impressions',
      type: 'number',
      aggType: 'sum',
      title: 'Impressions',
      format: 'number',
      description: 'Total impressions delivered',
      meta: {
        category: 'delivery',
        grain: 'daily',
        period: 'daily',
        type: 'actual',
        supports_rollup: true,
        supports_timeseries: true,
        formula: 'SUM(impressions)',
        inputs: [],
        short_description: 'Daily impressions delivered',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.clicks': {
      sql: 'clicks',
      type: 'number',
      aggType: 'sum',
      title: 'Clicks',
      format: 'number',
      description: 'Total clicks delivered',
      meta: {
        category: 'delivery',
        grain: 'daily',
        period: 'daily',
        type: 'actual',
        supports_rollup: true,
        supports_timeseries: true,
        formula: 'SUM(clicks)',
        inputs: [],
        short_description: 'Daily clicks delivered',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.video_views': {
      sql: 'video_views',
      type: 'number',
      aggType: 'sum',
      title: 'Video Views',
      format: 'number',
      description: 'Total video views delivered',
      meta: {
        category: 'delivery',
        grain: 'daily',
        period: 'daily',
        type: 'actual',
        supports_rollup: true,
        supports_timeseries: true,
        formula: 'SUM(video_views)',
        inputs: [],
        short_description: 'Daily video views delivered',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.video_completes': {
      sql: 'video_completes',
      type: 'number',
      aggType: 'sum',
      title: 'Video Completes',
      format: 'number',
      description: 'Total video completes delivered',
      meta: {
        category: 'delivery',
        grain: 'daily',
        period: 'daily',
        type: 'actual',
        supports_rollup: true,
        supports_timeseries: true,
        formula: 'SUM(video_completes)',
        inputs: [],
        short_description: 'Daily video completes delivered',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.conversions': {
      sql: 'conversions',
      type: 'number',
      aggType: 'sum',
      title: 'Conversions',
      format: 'number',
      description: 'Total conversions delivered',
      meta: {
        category: 'delivery',
        grain: 'daily',
        period: 'daily',
        type: 'actual',
        supports_rollup: true,
        supports_timeseries: true,
        formula: 'SUM(conversions)',
        inputs: [],
        short_description: 'Daily conversions delivered',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.actual_units': {
      sql: 'actual_units',
      type: 'number',
      aggType: 'sum',
      title: 'Actual Units',
      format: 'number',
      description:
        'Actual units delivered (impressions, clicks, video views, etc. based on unit price type). NULL for unassociated media buys.',
      meta: {
        category: 'delivery',
        grain: 'daily',
        period: 'daily',
        type: 'actual',
        supports_rollup: true,
        supports_timeseries: true,
        formula: 'SUM(actual_units)',
        inputs: [],
        short_description: 'Daily actual units delivered (impressions, clicks, etc.)',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.actual_spend': {
      sql: 'actual_spend',
      type: 'number',
      aggType: 'sum',
      title: 'Actual Spend',
      format: 'currency',
      description: 'Actual media spend from platform data',
      meta: {
        category: 'spend',
        grain: 'daily',
        period: 'daily',
        type: 'actual',
        supports_rollup: true,
        supports_timeseries: true,
        formula: 'SUM(actual_spend)',
        inputs: [],
        short_description: 'Daily actual media spend from platform data',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.cumulative_actual_spend': {
      sql: 'cumulative_actual_spend',
      type: 'number',
      aggType: 'max',
      title: 'Cumulative Actual Spend',
      format: 'currency',
      description: 'Running total of actual spend through this day',
      meta: {
        category: 'spend',
        grain: 'daily',
        period: 'cumulative',
        type: 'actual',
        supports_rollup: false,
        formula: 'MAX(cumulative_actual_spend)',
        inputs: [],
        short_description: 'Running total of actual spend through this day',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.cumulative_actual_units': {
      sql: 'cumulative_actual_units',
      type: 'number',
      aggType: 'max',
      title: 'Cumulative Actual Units',
      format: 'number',
      description: 'Running total of actual units through this day',
      meta: {
        category: 'delivery',
        grain: 'daily',
        period: 'cumulative',
        type: 'actual',
        supports_rollup: false,
        formula: 'MAX(cumulative_actual_units)',
        inputs: [],
        short_description: 'Running total of actual units through this day',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.unit_cost_incurred': {
      sql: 'media_buy_metrics_daily.actual_spend / NULLIF(media_buy_metrics_daily.actual_units, 0)',
      type: 'number',
      aggType: 'number',
      title: 'Unit Cost Incurred',
      format: 'currency',
      description: 'Actual cost per unit delivered. Spend / Units.',
      meta: {
        category: 'spend',
        grain: 'media_plan',
        type: 'derived',
        supports_rollup: false,
        supports_timeseries: false,
        formula: 'actual_spend / NULLIF(actual_units, 0)',
        inputs: ['media_buy_metrics_daily.actual_spend', 'media_buy_metrics_daily.actual_units'],
        short_description: 'Actual cost per unit delivered (spend / units)',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.media_revenue_earned': {
      sql: 'media_buy_metrics_daily.actual_units * media_buy_metrics_daily.line_items.unit_price * (1 - COALESCE(media_buy_metrics_daily.line_items.referral_commission_rate, 0))',
      type: 'number',
      aggType: 'sum',
      title: 'Media Revenue Earned',
      format: 'currency',
      description:
        'Revenue from delivered units: actual_units * effective_unit_price (unit_price net of referral commission). Uses line_items join.',
      meta: {
        category: 'revenue',
        grain: 'media_plan',
        type: 'derived',
        supports_rollup: true,
        supports_timeseries: true,
        formula: 'SUM(actual_units * unit_price * (1 - referral_commission_rate))',
        inputs: [
          'media_buy_metrics_daily.actual_units',
          'line_items.unit_price',
          'line_items.referral_commission_rate'
        ],
        short_description: 'Revenue from delivered units (actual_units * effective_unit_price)',
        source_tables: ['metrics.media_buy_metrics_daily', 'metrics.line_items']
      }
    } as const satisfies CubeMeasureEntry,
    'media_buy_metrics_daily.current_margin': {
      sql: '(media_buy_metrics_daily.media_revenue_earned - media_buy_metrics_daily.actual_spend) / NULLIF(media_buy_metrics_daily.media_revenue_earned, 0)',
      type: 'number',
      aggType: 'number',
      title: 'Current Margin',
      format: 'percent',
      description:
        'Actual margin percentage: (revenue - spend) / revenue. Uses media_revenue_earned and actual_spend.',
      meta: {
        category: 'margin',
        grain: 'media_plan',
        type: 'derived',
        supports_rollup: false,
        supports_timeseries: false,
        formula: '(media_revenue_earned - actual_spend) / NULLIF(media_revenue_earned, 0)',
        inputs: [
          'media_buy_metrics_daily.media_revenue_earned',
          'media_buy_metrics_daily.actual_spend'
        ],
        short_description: 'Actual margin: (revenue - spend) / revenue',
        source_tables: ['metrics.media_buy_metrics_daily', 'metrics.line_items']
      }
    } as const satisfies CubeMeasureEntry
  },
  dimensions: {
    'media_buy_metrics_daily.id': {
      sql: "media_buy_metrics_daily.media_buy_id || '-' || media_buy_metrics_daily.bucket::text",
      type: 'string',
      title: 'Id',
      primaryKey: true,
      meta: {
        short_description:
          'Composite key (media_buy_id + bucket) uniquely identifying each daily metric row.',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeDimensionEntry,
    'media_buy_metrics_daily.media_plan_id': {
      sql: 'media_plan_id',
      type: 'string',
      title: 'Media Plan ID',
      meta: {
        short_description: 'Parent media plan identifier. NULL for unassociated media buys.',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeDimensionEntry,
    'media_buy_metrics_daily.line_item_id': {
      sql: 'line_item_id',
      type: 'string',
      title: 'Line Item ID',
      meta: {
        short_description: 'Parent line item identifier. NULL for unassociated media buys.',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeDimensionEntry,
    'media_buy_metrics_daily.media_buy_id': {
      sql: 'media_buy_id',
      type: 'string',
      title: 'Media Buy ID',
      meta: {
        short_description: 'Platform media buy identifier. Always present.',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeDimensionEntry,
    'media_buy_metrics_daily.day': {
      sql: 'bucket',
      type: 'time',
      title: 'Date',
      meta: {
        short_description: 'Calendar date for daily metric record',
        source_tables: ['metrics.media_buy_metrics_daily']
      }
    } as const satisfies CubeDimensionEntry
  }
};
